/** @file The import dialog's new-project name field (choosing step, or a failed step with no project). */
import type { Translate } from '@pose2d/i18n/types';
import type { ImportSession } from './importTypes';

/** An editable name; a refused name (taken, invalid) is changed here and the import retried. */
export function ImportNameField({ t, name, session }: { t: Translate; name: string; session: ImportSession }) {
  return <label className="import-name">{t('psdImport.projectName')}<input value={name} onChange={(e) => { session.setProjectName(e.currentTarget.value); }} /></label>;
}
